module.exports = __webpack_public_path__ + "media/images/sprites/circle-1e8f106c310bd83f03f552d5a3cc9b70.svg";